import React from 'react';
import Button from '../../../components/ui/Button';

const FilterBar = ({ filters, onFilterChange }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Floor Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Floor
          </label>
          <select
            value={filters?.floor}
            onChange={(e) => onFilterChange({ ...filters, floor: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Floors</option>
            <option value="1">Floor 1</option>
            <option value="2">Floor 2</option>
            <option value="3">Floor 3</option>
            <option value="4">Floor 4</option>
            <option value="5">Floor 5</option>
          </select>
        </div>

        {/* Unit Type Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Unit Type
          </label>
          <select
            value={filters?.unitType}
            onChange={(e) => onFilterChange({ ...filters, unitType: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Types</option>
            <option value="hot_desk">Hot Desk</option>
            <option value="dedicated_desk">Dedicated Desk</option>
            <option value="private_cabin">Private Cabin</option>
            <option value="meeting_room">Meeting Room</option>
            <option value="conference_room">Conference Room</option>
          </select>
        </div>

        {/* Status Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Status
          </label>
          <select
            value={filters?.status}
            onChange={(e) => onFilterChange({ ...filters, status: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Status</option>
            <option value="vacant">Vacant</option>
            <option value="occupied">Occupied</option>
            <option value="under_maintenance">Under Maintenance</option>
            <option value="reserved">Reserved</option>
          </select>
        </div>

        {/* Reset Button */}
        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={() => onFilterChange({ floor: 'all', unitType: 'all', status: 'all' })}
            fullWidth
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;